export default __webpack_public_path__ + "static/media/bee_flower.f568b245.jpg";